import ApiService from '@/services/ApiService'
import resources from '@/data/campusResources'
import campusMutations  from './campusMutations'

export default {
    namespaced: false,
    state: {
        resources: resources,
        events: [],
        provinces: [],
        filters: {
            province:null,
            month: null
        },
        sort: 'asc'
    },
    actions: {
        fetchCampusEventsData({ commit }) {
            ApiService.getCampusEvents().then(response => {
                commit('setCampusEvents', response.data.events)
                commit('setCampusProvinces', response.data.provinces)
            })
        },
    },
    getters: {
        campusResources:state => state.resources,
        campusEvents:   state => state.resources,
    },
    mutations: {
        ...campusMutations,
    },
}